import workerFile from '!!raw-loader!@/Data/WebWorkers/Worker/errors.js';
import auth from '@/Data/Functions/auth';
import APIURLS from '@/Data/Objects/apiUrls';

/**
 * The logtype.
 */
export const LOGTYPE = {
    Information: 0,
    Warning: 1,
    Error: 2
};

/**
 * Sends a log request.
 * @param {object} logData Information describing the log
 */
export function SendLogRequest(logData) {
    if (!Array.isArray(logData) && logData.hasOwnProperty('LogType')) {
        logData = [logData];
    }

    logData = logData.filter(ld => ld.hasOwnProperty('LogMessage') && !ld.LogMessage.includes('ResizeObserver loop completed with undelivered notifications'));

    const messageData = {
        errors: logData,
        loggerUrl: APIURLS.logFromFrontEnd,
        locationProtocol: window.location.protocol,
        locationHost: window.location.host,
        bearerToken: auth.get()
    };

    if (typeof SharedWorker !== 'undefined') {
        window.errorworker.port.postMessage(messageData);
    }
    else {
        window.errorworker.postMessage(messageData);
    }
}

/**
 * Creates a new worker.
 */
export function CreateNewWorker() {
    const blob = new Blob([workerFile], { type: 'text/javascript' });

    if (typeof SharedWorker !== 'undefined') {
        window.errorworker = new SharedWorker(window.URL.createObjectURL(blob),
            {
                name: 'ErrorWorker'
            });

        window.errorworker.port.start();
        window.errorworker.port.onmessage = WorkerCallback;
    }
    else {
        window.errorworker = new Worker(window.URL.createObjectURL(blob), { name: 'ErrorWorker' });

        window.errorworker.onmessage = WorkerCallback;
    }
}

/**
 * Callback, called when the worker.
 * @param {object} event The event
 */
function WorkerCallback(event) {
    switch (event.data.type) {
        case 'INIT':
            // Do something, or nothing.
            break;
        case 'UPDATE_SUCCESS':
            // Do something, or nothing.
            break;
        case 'UPDATE_FAIL':
            // Do something, or nothing.
            break;
        case 'UPDATE_ERROR':
            // Do something, or nothing.
            break;
        case 'VALIDATIONERROR':
            // Do something, or nothing.
            break;
        case 'WORKERACTIONCOMPLETED':
            // Do something, or nothing.
            break;
        default:
            // Do something, or nothing.
            break;
    }
}
